export default __webpack_public_path__ + "static/media/pause-icon.863b8830.svg";